import { Box, Button } from '@mui/material/';
import { styled } from '@mui/material/styles';

export const StyledViewerContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  position: 'relative',
  marginBottom: theme.spacing(3),
}));

export const StyledDocumentHeaderBox = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
});

export const StyledDocumentBodyBox = styled(Box)({
  display: 'flex',
  width: '100%',
  height: 'calc(100vh - 200px)',
  flexDirection: 'column',
  overflowX: 'auto',
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
  minWidth: 0,
});

export const StyledDocumentButton = styled(Button)(({ theme }) => ({
  mr: theme.spacing(1),
  [theme.breakpoints.up('xs')]: {
    ...theme.typography.mobileParagraphBold,
  },
  [theme.breakpoints.up('xl')]: {
    ...theme.typography.paragraphBold,
  },
}));
